import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function OurClientThree() {
    return (
        <Container className='mb-3'>
            <Row className='text-center' >
                <Col>
                    <h3 className='about-two-h'> Here are some of our client’s comments about us- </h3>
                </Col>
            </Row>

            <Row >
                <Col className='text-center'>
                    <p className='about-two-p' >
                        “Royality Technologies has provided me with the best kind of service one could ask for. I was new to the world of security. I wanted to put CCTV around my house. My friend suggested Royality Technologies. I couldn't have asked for a better company to go to than them.”
                        <span className='text-center our_client_customer'> - Suraj Joshi <img className='feedback_icon' src='/images/icons/feedback.png' alt='Loading' /> </span>
                    </p>
                </Col>
            </Row>
            <div className='mt-3 mb-3' style={{ borderTop: '1px solid gray', width: '100%' }} >  </div>
            <Row >
                <Col className='text-center'>
                    <p className='about-two-p' >
                        “Our society's residents were afraid due to past incidents of robbery. We asked Royality Technologies to help and guide us through security systems that would be useful for our residents. We discovered CCTV and Doorbell cameras would have been most useful. After our agreement, the staff from Royality Technologies installed everything within a minimum amount of time. Now, the residents feel safer thanks to Royality Technologies.”
                        <span className='text-center our_client_customer'> - Ramananda Kashyap <img className='feedback_icon' src='/images/icons/feedback.png' alt='Loading' /> </span>
                    </p>
                </Col>
            </Row>

            <div className='mt-3 mb-3' style={{ borderTop: '1px solid gray', width: '100%' }} >  </div>
            <Row >
                <Col className='text-center'>
                    <p className='about-two-p' >
                        “We installed 4 Hikvision 5 years ago. Best night vision cameras. Great maintenance work. Thank you, Royality Technologies, for always providing service on time.”                     <span className='text-center our_client_customer'> - Prasanna Karmakar <img className='feedback_icon' src='/images/icons/feedback.png' alt='Loading' /> </span>
                    </p>
                </Col>
            </Row>

        </Container>
    )
}

export default OurClientThree